module.exports = __webpack_public_path__ + "static/cancompatibility-94494cdd4df82c8dc72e8bf3b78fc7ba.jpg";